import axios from './../http'

function add(data) {
    return axios.post('/sys/user/add', data);
}

function update(data) {
    return axios.post('/sys/user/update', data);
}

function get(id) {
    return axios.get('/sys/user/get?id=' + id);
}

function query(data) {
    return axios.post('/sys/user/query', data);
}

function valid(data) {
    return axios.post('/sys/user/valid', data);
}
function invalid(data) {
    return axios.post('/sys/user/invalid' , data);
}


function resetPwd(id) {
    return axios.get('/sys/user/resetPwd?id=' + id);
}





export default {
    query,
    valid,
    invalid,
    get,
    resetPwd,
    add,
    update
}